import React, { useEffect, useRef } from "react";
import { useTheme } from "../contexts/ThemeContext";

import HomeImage from "../images/sumit bhusal.jpg";

import Typed from "typed.js";

const Home = () => {
  const { isDarkMode } = useTheme();
  const el = useRef(null);
  const typed = useRef(null);

  useEffect(() => {
    const options = {
      strings: [
        "Full Stack Developer",
        "AI/ML Enthusiast"
      ],
      typeSpeed: 150,
      backSpeed: 150,
      loop: true,
    };

    typed.current = new Typed(el.current, options);

    return () => {
      typed.current.destroy();
    };
  }, []);

  const handleContactClick = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="bg-white pt-8 sm:pt-12 pb-2 sm:pb-6">
      <div className="max-w-6xl mx-auto px-4 sm:px-8">
        <div className="flex flex-col-reverse md:flex-row items-center md:items-center justify-between gap-8">
          {/* Left Content */}
          <div className="w-full md:w-1/2 text-center md:text-left flex flex-col justify-center">
            <h1 className="text-6xl sm:text-7xl md:text-9xl lg:text-[7rem] font-serif font-semibold mb-6">
              S<span className="text-green-400">umit</span> <br className="block md:hidden" />
              <span className="text-green-400">Bhu</span>
              sal
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl font-mono mb-4 text-gray-800 dark:text-gray-500">
              <span ref={el}></span>
            </p>
            <div className="space-y-4">
              <p className="text-2xl md:text-3xl font-mono text-gray-800 dark:text-gray-500">
                Crafting digital experiences that inspire and engage
              </p>
              <p className="text-xl md:text-2xl font-mono text-gray-800 dark:text-gray-500">
                Passionate about building modern web applications that solve real-world problems
              </p>
            </div>
            {/* Social Links */}
            <div className="flex justify-center md:justify-start gap-4 mt-6">
              <a
                href="https://www.linkedin.com/in/sumit-bhusal-247283259/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-blue-100 hover:bg-blue-200 transition"
                aria-label="LinkedIn"
              >
                {/* LinkedIn Icon */}
                <svg className="w-6 h-6 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 3A2 2 0 0 1 21 5V19A2 2 0 0 1 19 21H5A2 2 0 0 1 3 19V5A2 2 0 0 1 5 3H19M8.5 17V10.5H6V17H8.5M7.25 9.25A1.25 1.25 0 1 0 7.25 6.75A1.25 1.25 0 0 0 7.25 9.25M18 17V13.25C18 11.6 16.4 11.5 16.4 13.25V17H13.9V10.5H16.3V11.75C16.7 11.1 17.6 10.5 18.5 10.5C20.1 10.5 20 11.6 20 13.25V17H18Z" />
                </svg>
              </a>
              <a
                href="https://github.com/Sumit-Bhusal"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-gray-200 hover:bg-gray-300 transition"
                aria-label="GitHub"
              >
                {/* GitHub Icon */}
                <svg className="w-6 h-6 text-gray-800" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    fillRule="evenodd"
                    d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0 1 12 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0 0 22 12.017C22 6.484 17.522 2 12 2z"
                    clipRule="evenodd"
                  />
                </svg>
              </a>
            </div>
          </div>
          {/* Right Image */}
          <div className="w-full md:w-1/2 flex justify-center md:justify-end">
            <img
              src={HomeImage}
              alt="Profile"
              className="w-64 h-64 sm:w-96 sm:h-96 md:w-[450px] md:h-[450px] lg:w-[600px] lg:h-[600px] rounded-2xl shadow-2xl object-cover object-center transform hover:scale-105 transition-transform duration-300"
            />
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default Home;
